import { AbstractControl } from '@angular/forms';

export const creditCardNumber = function rule_creditcard_no(
  control: AbstractControl
): { [key: string]: boolean } {
  const value = control.value || '';
  const knr = value.replace(/\s/g, '');

  if (!rule_number_with_spaces(knr, 15)) {
    return {
      creditCardNumber: true,
    };
  }

  let sum = 0;
  const x = 0;
  let txt;
  let gw = 1;

  for (let i = knr.length - 1; i >= 0; i--) {
    // Prüfung entfällt da rule_number_with_spaces() diesen Fall überprüft!
    //if ( _ds_ziffer( i, knr ) != -1 ){
    sum += _ds_quersumme(_ds_ziffer(i, knr) * gw);
    gw = 3 - gw;
    //}
  }

  const is_valid =
    sum % 10 === 0 && knr !== '' && !isNaN(knr) && knr.length > 10;
  if (!is_valid) {
    return {
      creditCardNumber: true,
    };
  }

  return null;
};

export const creditCardCvc = function rule_creditcard_cvc(
  control: AbstractControl
): { [key: string]: boolean } {
  const value = control.value || '';
  if (!rule_number_with_spaces(value, 3)) {
    return { creditCardCvc: true };
  }
  return null;
};

export const creditCardExpire = function(control: AbstractControl): {
  [key: string]: boolean;
} {
  const error = { creditCardExpire: true };
  const value = control.value || '';
  const [monthInput, yearInput] = value.split('/', 2);
  const month = parseInt(monthInput, 10);
  const yearSuffix = parseInt(yearInput, 10);
  if (month > 12 || month < 1 || yearSuffix > 99 || yearSuffix < 0) {
    return error;
  }

  const current = new Date();
  const expire = new Date(yearSuffix + 2000, month);
  if (current.getTime() > expire.getTime()) {
    return error;
  }

  return null;
};

function _ds_quersumme(x) {
  return (x % 10) + Math.floor(x / 10);
}
function _ds_ziffer(i, txt) {
  // entfällt da nach rule_number_with_spaces() prüfen keine Nummern mehr
  // existieren
  // if ( txt.charAt(i) < '0' || txt.charAt(i) > '9')  {
  //  return -1;
  // }
  return parseInt(txt.slice(i, i + 1), 10);
}

function rule_number_with_spaces(value: string, minLength: number) {
  const value_to_parse = value.replace(/\s/g, '');

  return value_to_parse.length >= minLength && rule_numeric(value_to_parse);
}

export const routingNumber = function rule_routing_no(
  control: AbstractControl
): { [key: string]: boolean } {
  const value = control.value || '';
  if (!rule_number_with_spaces(value, 5)) {
    return { routingNumber: true };
  }
  return null;
};

export const accountNumber = function rule_account_no(
  control: AbstractControl
): { [key: string]: boolean } {
  const value = control.value || '';
  if (!rule_number_with_spaces(value, 5)) {
    return { accountNumber: true };
  }
  return null;
};

export const bic = function rule_bic(control: AbstractControl): {
  [key: string]: boolean;
} {
  const value = control.value || '';
  if (!value) {
    return null;
  }
  if (!rule_min_length(value, 4)) {
    return { bic: true };
  }
  return null;
};

function rule_min_length(value: string, min: number) {
  return value.length >= min;
}

function rule_numeric(value: string) {
  return /^[0-9]{1,}$/.test(value.trim());
}
